import './MultivalueDisplayReport.css';
import { t } from 'i18next';
import React from 'react';
import { connect } from 'react-redux';
import Loading from '../../loading/Loading';
import { numberFormatter } from '../../../helpers/formatter';

const { keys } = Object;

const MultiValueDisplayReport = ({
  title, data, noBorder = false,
}) => {
  const template = (obj) => {
    let computedTemplate = null;
    switch (obj.type) {
      case 'date':
        computedTemplate = obj.value
          ? <div className="date"><span>{obj.value}</span></div>
          : <Loading size={20} />;
        break;
      case 'strValue':
        computedTemplate = obj.value
          ? <div className={`value ${obj.value === t('unableToFetchData') ? 'unable-to-fetch-data' : ''}`}>
            {numberFormatter(obj.value, false)}
        </div>
          : <Loading size={20} />;
        break;
      case 'perValue':
        computedTemplate = obj.value && obj.value[0] ? (
          <div className="value">
            {
              <span style={{
                color: `${obj.color}`,
              }}
              >
                {numberFormatter(obj.value[0])}
              </span>
            }
            {'/'}
            {
              <span style={{
                color: '#afafaf',
              }}
              >
                {numberFormatter(obj.value[1])}
              </span>
            }
          </div>
        ) : <Loading size={20} />;
        break;
      default:
    }
    return computedTemplate;
  };

  return (
    <div className={`MultivalueDisplay report ${noBorder ? 'noborder' : ''}`}>
      <h2>{t(title)}</h2>
      { keys(data).map(key => (
        <div key={key}>
          <span className="title">{t(key)}</span>
          {template(data[key])}
        </div>
      ))}
    </div>
  );
};

export default connect()(MultiValueDisplayReport);
